// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Print-specific styles */
@media print {
  /* Hide navigation, sidebar, and interactive elements during print */
  .navbar,
  .navbar-fixed-top,
  .sidebar-offcanvas,
  .wt-sidebar,
  .wt-rte-toolbar,
  .btn,
  .breadcrumb,
  .pagination,
  .footer,
  #sidebar,
  .dropdown-menu,
  .wt-content-view-filter {
    display: none !important;
  }

  /* Remove fixed positioning */
  .navbar-fixed-top {
    position: static !important;
  }

  /* Full-width content */
  .container-fluid,
  .container,
  .col-sm-12,
  .col-md-9,
  .col-lg-9-x {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .row-offcanvas {
    display: block !important;
  }

  /* Clean typography */
  body {
    font-size: 12pt !important;
    line-height: 1.5 !important;
    color: #000 !important;
    background: #fff !important;
  }

  h1 { font-size: 18pt !important; }
  h2 { font-size: 16pt !important; }
  h3 { font-size: 14pt !important; }

  /* Show link targets */
  a[href]:not([href^="#"])::after {
    content: " (" attr(href) ")";
    font-size: 10pt;
    font-weight: normal;
    color: #666;
  }

  /* Page breaks */
  .panel {
    page-break-inside: avoid;
  }

  .page-header {
    page-break-after: avoid;
  }

  /* Remove box shadows and borders */
  .panel,
  .well,
  .jumbotron {
    box-shadow: none !important;
    border: 1px solid #ddd !important;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/styles/print.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,oEAAoE;EACpE;;;;;;;;;;;;IAYE,wBAAwB;EAC1B;;EAEA,6BAA6B;EAC7B;IACE,2BAA2B;EAC7B;;EAEA,uBAAuB;EACvB;;;;;IAKE,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,qBAAqB;EACrB;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA,KAAK,0BAA0B,EAAE;EACjC,KAAK,0BAA0B,EAAE;EACjC,KAAK,0BAA0B,EAAE;;EAEjC,sBAAsB;EACtB;IACE,4BAA4B;IAC5B,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA,gBAAgB;EAChB;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;;EAEA,mCAAmC;EACnC;;;IAGE,2BAA2B;IAC3B,iCAAiC;EACnC;AACF","sourcesContent":["/* Print-specific styles */\n@media print {\n  /* Hide navigation, sidebar, and interactive elements during print */\n  .navbar,\n  .navbar-fixed-top,\n  .sidebar-offcanvas,\n  .wt-sidebar,\n  .wt-rte-toolbar,\n  .btn,\n  .breadcrumb,\n  .pagination,\n  .footer,\n  #sidebar,\n  .dropdown-menu,\n  .wt-content-view-filter {\n    display: none !important;\n  }\n\n  /* Remove fixed positioning */\n  .navbar-fixed-top {\n    position: static !important;\n  }\n\n  /* Full-width content */\n  .container-fluid,\n  .container,\n  .col-sm-12,\n  .col-md-9,\n  .col-lg-9-x {\n    width: 100% !important;\n    max-width: 100% !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  .row-offcanvas {\n    display: block !important;\n  }\n\n  /* Clean typography */\n  body {\n    font-size: 12pt !important;\n    line-height: 1.5 !important;\n    color: #000 !important;\n    background: #fff !important;\n  }\n\n  h1 { font-size: 18pt !important; }\n  h2 { font-size: 16pt !important; }\n  h3 { font-size: 14pt !important; }\n\n  /* Show link targets */\n  a[href]:not([href^=\"#\"])::after {\n    content: \" (\" attr(href) \")\";\n    font-size: 10pt;\n    font-weight: normal;\n    color: #666;\n  }\n\n  /* Page breaks */\n  .panel {\n    page-break-inside: avoid;\n  }\n\n  .page-header {\n    page-break-after: avoid;\n  }\n\n  /* Remove box shadows and borders */\n  .panel,\n  .well,\n  .jumbotron {\n    box-shadow: none !important;\n    border: 1px solid #ddd !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
